<template>
    <div>
        <v-combobox
            v-show="!hiddenField(access)"
            v-model="tagsValue"
            chips
            :clearable="!readonlyField(access)"
            multiple
            flat
            return-object
            :delimiters="[delimiter]"
            :items="tagsSelectItems()"
            item-text="value"
            item-value="key"
            item-color="color"
            :id="id"
            :label="label"
            :type="fieldTextType(dataType)"
            :required="requiredField(access)"
            :readonly="readonlyField(access)"
            :disabled="loading"
            :filled="readonlyField(access) || queryFlag"
            :rules="rules"
            :outlined="queryFlag"
            :dense="queryFlag"
            :single-line="queryFlag"
            :hide-details="queryFlag"
            @input="handleChange"
            :search-input.sync="search"
            @update:search-input="searchInput"
            autocomplete="off"
        >
            <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    :close="!readonlyField(access)"
                    :href="link({ item })"
                    :target="target({ item })"
                    small
                    outlined
                    close-icon="mdi-close"
                    @click="select"
                    @click:close="removeTag(item)"
                >
                    <strong>{{ item }}</strong>
                </v-chip>
            </template>
        </v-combobox>
    </div>
</template>

<script>
export default {
    name: "TagsField",
    props: [
        "label",
        "value",
        "access",
        "pattern",
        "id",
        "items",
        "name",
        "rules",
        "tags",
        "list",
        "dataType",
        "loading",
        "queryFlag",
        "coordinates",
        "dictionary",
        "generalExApplicationEx",
        "customLanguage",
    ],
    data() {
        console.log(this.value);

        const isList = this.comboTagListField(this.dictionary);
        const isString = typeof this.value === "string";
        const stringValue = isString ? this.value : this.value?.toString();
        const arrayValue = isList
            ? isString
                ? JSON.parse(this.value)
                : this.value ?? []
            : stringValue?.split(",");

        let arrayFormatted = [];
        if (this.formattedItems().length > 0) {
            arrayValue?.forEach((tag) => {
                const find = this.formattedItems().find((item) => {
                    return item.key == tag;
                });
                if (find) {
                    arrayFormatted.push(find.value);
                }
            });
        } else {
            arrayFormatted = arrayValue;
        }

        return {
            defaultValue: stringValue,
            currentValue: stringValue,
            tagsValue: arrayFormatted,
            autoSource: null,
            delimiter: ",",
            search: null,
        };
    },
    methods: {
        handleChange() {
            console.log("handleChange");
            let handledValue = [];

            if (this.formattedItems().length > 0) {
                this.tagsValue.forEach((tag) => {
                    const find = this.formattedItems().find((item) => {
                        return item.value == tag;
                    });
                    if (find) {
                        handledValue.push(find.key);
                    }
                });
            } else {
                handledValue = this.tagsValue;
            }

            const uniqueValues = [...new Set(handledValue)];
            this.currentValue = this.comboTagListField(this.dictionary)
                ? uniqueValues
                : uniqueValues.toString();

            const data = {
                value: this.currentValue,
                id: this.id,
                autoSource: this.autoSource,
                coordinates: this.coordinates,
            };
            this.$emit("field-change", data);
        },
        tagsSelectItems() {
            let result = [];

            this.items.forEach((item) => {
                result.push(
                    this.translatedConfig(
                        this.generalExApplicationEx,
                        this.customLanguage,
                        item,
                        "itemName"
                    )
                );
            });

            return result;
        },
        removeTag(item) {
            if (!this.readonlyField(this.access)) {
                this.tagsValue.splice(this.tagsValue.indexOf(item), 1);
                this.tagsValue = [...this.tagsValue];
                this.handleChange();
            }
        },
        setValue(value, autoSource) {
            this.currentValue = value;
            this.autoSource = autoSource;
            this.handleChange();
        },
        searchInput() {
            if (this.search && this.search.split(this.delimiter).length > 1) {
                this.tagsValue = this.tagsValue.concat(
                    this.search
                        .split(this.delimiter)
                        .filter(
                            (term) =>
                                !this.tagsValue.includes(term) && term != ""
                        )
                );
                this.handleChange();
                this.search = "";
            }
        },
        formattedItems() {
            const keyFieldName = "itemId";
            const colorFieldName = "itemColor";
            const result = this.items.map((item) => {
                return {
                    key: item[keyFieldName],
                    value: this.translatedConfig(
                        this.generalExApplicationEx,
                        this.customLanguage,
                        item,
                        "itemName"
                    ),
                    color: item[colorFieldName],
                };
            });
            return result;
        },
        link({ item }) {
            if (this.validateUrl(item)) {
                return item;
            } else {
                return null;
            }
        },
        target({ item }) {
            if (this.validateUrl(item)) {
                return "_blank";
            } else {
                return null;
            }
        },
    },
    updated() {},
};
</script>

<style scoped>
</style>